const poutrelles = [
  {
    id: "poutrelle-hea",
    title: "Poutrelle HEA",
    image: "/assets/images/products/Poutrelle HEA.webp",
    specImage: "Poutrelle HEA.webp",
    description: "Poutrelle à larges ailes légères",
    longDescription: "Disponibles en qualité S 235 JRG (ST37) S275JRG2 et S 355J2G3 selon NF EN 10025 avec aptitude à la galvanisation. Disponibles en longueurs métriques de 6, 12, 10 et 15,10 mètres. Certificat 2.2 ou 3.1 B selon NF EN 10204.",
    category: "poutrelles",
    specifications: [
      "Tableaux de spécificités détaillés disponibles",
      "Parois plus minces que la HEB",
      "Qualité S 235 JRG (ST37) S275JRG2 et S 355J2G3",
      "Longueurs métriques de 6, 12, 10 et 15,10 mètres",
      "Certificat 2.2 ou 3.1 B selon NF EN 10204"
    ]
  },
  {
    id: "poutrelle-heb",
    title: "Poutrelle HEB",
    image: "/assets/images/products/Poutrelle HEB.webp",
    specImage: "Poutrelle HEB.webp",
    description: "Poutrelle à larges ailes à faces parallèles",
    longDescription: "Disponibles en qualité S 235 JRG (ST37) S275JRG2 et S 355J2G3 selon NF EN 10025 avec aptitude à la galvanisation. Disponibles en longueurs métriques de 6, 12, 10 et 15,10 mètres. Certificat 2.2 ou 3.1 B selon NF EN 10204.",
    category: "poutrelles",
    specifications: [
      "Tableaux de spécificités détaillés disponibles",
      "Ailes parallèles et larges",
      "Qualité S 235 JRG (ST37) S275JRG2 et S 355J2G3",
      "Longueurs métriques de 6, 12, 10 et 15,10 mètres",
      "Certificat 2.2 ou 3.1 B selon NF EN 10204"
    ]
  },
  {
    id: "poutrelle-ipe",
    title: "Poutrelle IPE",
    image: "/assets/images/products/Poutrelle IPE.webp",
    specImage: "Poutrelle IPE.webp",
    description: "Poutrelle à ailes parallèles européenne",
    longDescription: "Disponibles en qualité S 235 JRG (ST37) S275JRG2 et S 355J2G3 selon NF EN 10025 avec aptitude à la galvanisation. Disponibles en longueurs métriques de 6, 12, 10 et 15,10 mètres. Certificat 2.2 ou 3.1 B selon NF EN 10204.",
    category: "poutrelles",
    specifications: [
      "Tableaux de spécificités détaillés disponibles",
      "Profil optimisé pour la résistance à la flexion",
      "Qualité S 235 JRG (ST37) S275JRG2 et S 355J2G3",
      "Longueurs métriques de 6, 12, 10 et 15,10 mètres",
      "Certificat 2.2 ou 3.1 B selon NF EN 10204"
    ]
  },
  {
    id: "poutrelle-upn",
    title: "Poutrelle UPN",
    image: "/assets/images/products/Poutrelle UPN.webp",
    specImage: "Poutrelle UPN.webp",
    description: "Profil en U normalisé européen",
    longDescription: "Disponibles en qualité S 235 JRG (ST37) S275JRG2 et S 355J2G3 selon NF EN 10025 avec aptitude à la galvanisation. Disponibles en longueurs métriques de 6, 12, 10 et 15,10 mètres. Certificat 2.2 ou 3.1 B selon NF EN 10204.",
    category: "poutrelles",
    specifications: [
      "Tableaux de spécificités détaillés disponibles",
      "Profil en U avec faces intérieures inclinées",
      "Qualité S 235 JRG (ST37) S275JRG2 et S 355J2G3",
      "Longueurs métriques de 6, 12, 10 et 15,10 mètres",
      "Certificat 2.2 ou 3.1 B selon NF EN 10204"
    ]
  }
];

export default poutrelles;
